// extracted by mini-css-extract-plugin
export default {"registration-button":"cZcLi2","registrationButton":"cZcLi2","disabled":"c_Gi9A","primary":"rXbNmm","secondary":"IikhGe","link":"GwpHQu","narrowerButton":"o9MIDc"};